/* global window */

import rjsConfig from './lib/viewer/rjs-config.js'

const options = require('json!./options/pLoaderConfig.json')
const getViewerRjsConfig = rjsConfig(window, options.versions)

module.exports = function (serviceTopology, baseVersion, PackagesUtil) {
  const packages = options.packages

  let config = getViewerRjsConfig(serviceTopology)

  config.injects = {
    // lodash: 'lodash'
  }
  const packagesUtil = new PackagesUtil(packages, window.location.search)
  config = packagesUtil.buildConfig(config)
  config.baseUrl = baseVersion
  config.versions = {}
  return config
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/pLoaderConfig.js